export const INITIAL_LETTER_OF_NATIONAL_REGISTRATION_CARD_NUMBER = ['S', 'T'];
export const INITIAL_LETTER_OF_FOREIGN_IDENTIFICATION_NUMBER = ['F', 'G', 'M'];
export const MINIMUM_AGE = 18;
export const SGP_NAME_ALLOWED_CHARACTER_REGEX = /^[ ',/A-Za-z-]{1,50}$/;
export const SGP_MIDDLE_NAME_ALLOWED_CHARACTER_REGEX = /^[ ',/A-Za-z-]{1,40}$/;
